import { createAction } from 'typesafe-actions';

// intermittent background poll to keep the ui relatively fresh
export const pollBackgroundAccountUpdateState = createAction(
  'POLL/BACKGROUND_ACCOUNT_UPDATE_STATE',
  (resolve) => {
    return (payload: { account_id: number | null }) => resolve(payload);
  }
);
